(() => {
  document.documentElement.classList.remove('no-js');

  const moneyText = (value) => value;

  function updateBagCount(count) {
    document.querySelectorAll('.bt-bag-link').forEach((link) => {
      link.textContent = `BAG  (${count})`;
    });
  }

  function initNewsletter() {
    const shell = document.querySelector('[data-newsletter-shell]');
    if (!shell) return;

    const newsletter = shell.querySelector('[data-newsletter]');
    if (!newsletter) return;

    const toggles = newsletter.querySelectorAll('[data-newsletter-toggle]');
    const input = newsletter.querySelector('.bt-newsletter__input');
    const inputWrap = newsletter.querySelector('[data-newsletter-input-wrap]');
    const customCaret = newsletter.querySelector('[data-newsletter-caret]');
    const textMirror = newsletter.querySelector('[data-newsletter-mirror]');
    const heading = newsletter.querySelector('.bt-newsletter__heading');
    const label = newsletter.querySelector('.bt-newsletter__label');
    const form = newsletter.closest('form');
    const error = newsletter.querySelector('[data-newsletter-error]');
    const submit = newsletter.querySelector('.bt-newsletter__submit');
    const confirmation = shell.querySelector('[data-newsletter-confirmation]');
    const frame = shell.querySelector('.bt-reference-frame');
    const homeScreen = shell.querySelector('[data-bt-screen="home"]');
    const serverResult = newsletter.dataset.newsletterResult || 'idle';

    /* We own the visual validation states so Safari never inserts its own
       validation bubble into the reference composition. */
    form?.setAttribute('novalidate', 'novalidate');
    let errorResetTimer = null;
    let successTimer = null;
    let invalidGuardUntil = 0;

    /* Mobile/in-app browsers can synthesize a late click after SUBMIT.
       Block only interface navigation while the invalid animation/reset is active,
       so that late click can never be retargeted to CONTACT. */
    const invalidNavigationGuardActive = () => Date.now() < invalidGuardUntil || Boolean(shell.dataset.newsletterInvalidLock);

    /* A mobile browser can emit a second/retargeted CLICK from the same tap after
       the INVALID state changes underneath the finger. A timer alone cannot
       reliably distinguish that ghost click from a real later tap. After the
       invalid animation finishes we therefore keep navigation locked until a
       genuinely NEW pointer/touch begins. That fresh gesture unlocks navigation
       before its own click is generated, while a ghost click (which has no new
       pointerdown/touchstart) is swallowed. */
    const unlockOnFreshGesture = (event) => {
      if (shell.dataset.newsletterInvalidLock !== 'await-fresh-pointer') return;
      shell.removeAttribute('data-newsletter-invalid-lock');
      invalidGuardUntil = 0;
    };
    shell.addEventListener('pointerdown', unlockOnFreshGesture, true);
    shell.addEventListener('touchstart', unlockOnFreshGesture, true);

    const guardInvalidNavigation = (event) => {
      if (!invalidNavigationGuardActive()) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('[data-bt-screen-target]')) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
    };
    shell.addEventListener('pointerup', guardInvalidNavigation, true);
    shell.addEventListener('touchend', guardInvalidNavigation, true);
    shell.addEventListener('click', guardInvalidNavigation, true);
    const caretCanvas = document.createElement('canvas');
    const caretContext = caretCanvas.getContext('2d');

    const isEmailValid = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const hideCustomCaret = () => {
      inputWrap?.classList.remove('is-caret-visible');
    };

    const updateTextMirror = () => {
      if (!input || !textMirror) return;
      textMirror.textContent = input.value || '';
      textMirror.style.transform = `translate(${-input.scrollLeft}px, -50%)`;
    };

    const updateCustomCaret = ({ resetBlink = false } = {}) => {
      updateTextMirror();
      if (!input || !inputWrap || !customCaret || document.activeElement !== input) {
        hideCustomCaret();
        return;
      }
      if (newsletter.classList.contains('has-error') || newsletter.classList.contains('is-success') || input.readOnly) {
        hideCustomCaret();
        return;
      }

      const computed = window.getComputedStyle(input);
      const value = computed.textTransform === 'uppercase' ? input.value.toUpperCase() : input.value;
      let caretIndex = value.length;
      try {
        if (typeof input.selectionStart === 'number') caretIndex = input.selectionStart;
      } catch (error) {}

      const beforeCaret = value.slice(0, caretIndex);
      const paddingLeft = parseFloat(computed.paddingLeft) || 0;
      const paddingRight = parseFloat(computed.paddingRight) || 0;
      const letterSpacing = parseFloat(computed.letterSpacing) || 0;

      let textWidth = beforeCaret.length * (parseFloat(computed.fontSize) || 16) * 0.6;
      let caretWidth = parseFloat(computed.fontSize) || 16;
      if (caretContext) {
        caretContext.font = computed.font;
        textWidth = caretContext.measureText(beforeCaret).width + Math.max(0, beforeCaret.length) * letterSpacing;
        caretWidth = caretContext.measureText('…').width;
      }

      const naturalLeft = paddingLeft + textWidth - input.scrollLeft;
      const maxLeft = Math.max(paddingLeft, input.clientWidth - paddingRight - caretWidth);
      const left = Math.max(paddingLeft, Math.min(naturalLeft, maxLeft));
      customCaret.style.left = `${left}px`;
      inputWrap.classList.add('is-caret-visible');

      if (resetBlink) {
        customCaret.style.animation = 'none';
        void customCaret.offsetWidth;
        customCaret.style.animation = '';
      }
    };

    const setAria = (invalid) => {
      input?.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    };

    /* Center the 42px-on-a-1920px-master bar between the actual rendered
       MAILING LIST and EMAIL ADDRESS line boxes. This makes the empty space
       above and below the bar mathematically equal on every phone/font metric. */
    const centerInputBar = () => {
      if (!frame || !inputWrap || !heading || !label) return;
      const frameRect = frame.getBoundingClientRect();
      const headingRect = heading.getBoundingClientRect();
      const labelRect = label.getBoundingClientRect();
      if (!frameRect.height) return;

      const barHeight = frameRect.height * (42 / 1920);
      const gapTop = headingRect.bottom;
      const gapBottom = labelRect.top;
      const topPx = ((gapTop + gapBottom - barHeight) / 2) - frameRect.top;
      inputWrap.style.top = `${(topPx / frameRect.height) * 100}%`;
      inputWrap.style.height = `${(barHeight / frameRect.height) * 100}%`;
    };

    const open = ({ focus = true } = {}) => {
      newsletter.classList.add('is-open');
      heading?.classList.add('is-active');
      centerInputBar();
      if (focus) window.requestAnimationFrame(() => {
        /* Opening MAILING LIST must never let the browser pan/scroll the
           composition to reveal the input. Keep the viewport exactly where it
           was and focus without scrolling when supported. */
        const x = window.scrollX;
        const y = window.scrollY;
        try { input?.focus({ preventScroll: true }); }
        catch (error) { input?.focus(); }
        if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
      });
    };

    const clearVisualStates = () => {
      newsletter.classList.remove('has-error', 'is-success');
      setAria(false);
      if (submit) submit.textContent = 'SUBMIT';
      if (error) error.textContent = '';
    };

    const showConfirmation = () => {
      if (errorResetTimer) window.clearTimeout(errorResetTimer);
      if (successTimer) window.clearTimeout(successTimer);
      shell.classList.add('is-newsletter-confirmed');
      if (homeScreen) homeScreen.setAttribute('aria-hidden', 'true');
      if (confirmation) {
        confirmation.hidden = false;
        confirmation.setAttribute('aria-hidden', 'false');
      }
    };

    const showInvalid = () => {
      if (!input) return;
      if (errorResetTimer) window.clearTimeout(errorResetTimer);
      if (successTimer) window.clearTimeout(successTimer);

      open({ focus: false });
      /* Lock interface navigation for the full invalid-email interaction.
         Some mobile/in-app browsers can dispatch a delayed/retargeted click
         after the submit tap; without this guard that click can land on CONTACT. */
      shell.dataset.newsletterInvalidLock = 'true';
      invalidGuardUntil = Date.now() + 2500;
      newsletter.classList.remove('is-success');
      newsletter.classList.add('has-error');
      setAria(true);
      if (error) error.textContent = 'Please enter a valid email address.';

      /* Keep the actual invalid address visible in the burgundy bar.
         The action label itself becomes INVALID in the same burgundy tone. */
      const invalidValue = input.value;
      input.readOnly = true;
      hideCustomCaret();
      input.value = invalidValue;
      updateTextMirror();
      input.blur();
      if (submit) submit.textContent = 'INVALID';

      /* Burgundy error flash, then return to a blank white field and SUBMIT. */
      errorResetTimer = window.setTimeout(() => {
        newsletter.classList.remove('has-error');
        setAria(false);
        input.value = '';
        updateTextMirror();
        input.readOnly = false;
        if (submit) submit.textContent = 'SUBMIT';
        if (error) error.textContent = '';
        centerInputBar();
        /* Return to the clean, empty white bar without programmatically
           refocusing it. On mobile/in-app browsers that focus could trigger
           an unintended interface interaction after the INVALID animation. */
        input.blur();
        hideCustomCaret();
        /* Keep navigation locked after the visual reset until the visitor
           starts a genuinely new touch/pointer gesture. This prevents the
           original SUBMIT tap from being retargeted to CONTACT after layout/
           state changes, while still allowing the very next intentional tap. */
        shell.dataset.newsletterInvalidLock = 'await-fresh-pointer';
        invalidGuardUntil = Number.POSITIVE_INFINITY;
      }, 900);
    };

    const showAcceptedThenConfirmation = (emailValue, { immediate = false } = {}) => {
      if (!input) return;
      if (errorResetTimer) window.clearTimeout(errorResetTimer);
      if (successTimer) window.clearTimeout(successTimer);

      open({ focus: false });
      newsletter.classList.remove('has-error');
      newsletter.classList.add('is-success');
      setAria(false);
      input.readOnly = true;
      hideCustomCaret();
      if (emailValue) input.value = emailValue;
      updateTextMirror();
      input.blur();
      if (error) error.textContent = '';

      /* The yellow accepted bar is visible briefly, then the interface changes
         automatically to EMAIL ADDRESS / SUBMITTED — no second tap required. */
      if (immediate) {
        showConfirmation();
      } else {
        successTimer = window.setTimeout(showConfirmation, 450);
      }
    };

    /* Use Shopify's normal top-level customer/newsletter form submission.
       Do not submit through a hidden iframe or alternate target: those non-standard
       submissions can provoke Shopify's anti-bot challenge flow even when the store
       hCaptcha preference is disabled. */
    form?.removeAttribute('target');

    const resetNewsletterToIdle = () => {
      if (errorResetTimer) {
        window.clearTimeout(errorResetTimer);
        errorResetTimer = null;
      }
      if (successTimer) {
        window.clearTimeout(successTimer);
        successTimer = null;
      }

      /* Preserve the post-invalid ghost-click lock. It is released only by a
         genuinely new pointer/touch start (see unlockOnFreshGesture above). */
      if (shell.dataset.newsletterInvalidLock !== 'await-fresh-pointer') {
        delete shell.dataset.newsletterInvalidLock;
      }
      newsletter.classList.remove('is-open', 'has-error', 'is-success');
      heading?.classList.remove('is-active');
      setAria(false);
      hideCustomCaret();

      if (input) {
        input.readOnly = false;
        input.blur();
      }
      if (submit) {
        submit.textContent = 'SUBMIT';
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
      }
      if (error) error.textContent = '';

      shell.classList.remove('is-newsletter-confirmed');
      if (homeScreen) homeScreen.setAttribute('aria-hidden', 'false');
      if (confirmation) {
        confirmation.hidden = true;
        confirmation.setAttribute('aria-hidden', 'true');
      }
    };

    /* The outer Burgintee interface dispatches this when the visitor taps
       empty space. It closes the mailing-list state without moving anything. */
    shell.addEventListener('burgintee:reset-newsletter', resetNewsletterToIdle);

    toggles.forEach((toggle) => toggle.addEventListener('click', () => {
      if (shell.classList.contains('is-newsletter-confirmed')) return;
      if (newsletter.classList.contains('is-success')) return;

      /* MAILING LIST behaves like every other category: tap once to open and
         highlight it; tap the highlighted heading again to close/unhighlight.
         EMAIL ADDRESS remains an input-control shortcut and continues to focus
         the field rather than collapsing the category. */
      const isHeadingToggle = toggle.classList.contains('bt-newsletter__heading');
      if (isHeadingToggle && newsletter.classList.contains('is-open')) {
        resetNewsletterToIdle();
        return;
      }

      clearVisualStates();
      if (input) input.readOnly = false;
      open();
    }));

    input?.addEventListener('input', () => {
      updateTextMirror();
      if (newsletter.classList.contains('has-error')) return;
      newsletter.classList.remove('is-success');
      setAria(false);
      if (error) error.textContent = '';
      window.requestAnimationFrame(() => updateCustomCaret({ resetBlink: true }));
    });

    input?.addEventListener('focus', () => window.requestAnimationFrame(() => updateCustomCaret({ resetBlink: true })));
    input?.addEventListener('blur', hideCustomCaret);
    input?.addEventListener('click', () => window.requestAnimationFrame(() => updateCustomCaret({ resetBlink: true })));
    input?.addEventListener('keyup', () => window.requestAnimationFrame(() => updateCustomCaret({ resetBlink: true })));
    input?.addEventListener('select', () => window.requestAnimationFrame(updateCustomCaret));
    input?.addEventListener('scroll', () => { updateTextMirror(); window.requestAnimationFrame(updateCustomCaret); }, { passive: true });
    input?.addEventListener('touchend', () => window.setTimeout(() => updateCustomCaret({ resetBlink: true }), 0), { passive: true });
    document.addEventListener('selectionchange', () => {
      if (document.activeElement === input) window.requestAnimationFrame(updateCustomCaret);
    });

    window.addEventListener('resize', centerInputBar, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(centerInputBar).catch(() => {});
    window.requestAnimationFrame(centerInputBar);
    updateTextMirror();

    if (serverResult === 'success') {
      showAcceptedThenConfirmation(input?.value || '', { immediate: true });
    } else if (serverResult === 'error') {
      showInvalid();
    }

    /* Own newsletter submission completely. Shopify's generated customer form
       posts to a /contact URL, which can make this single-page interface reopen
       the CONTACT screen after SUBMIT. Never allow the newsletter button to
       navigate the page. Submit the same Shopify form in the background instead. */
    let newsletterSubmitting = false;

    const processNewsletterSubmit = async () => {
      if (!input || !form || newsletterSubmitting) return;

      const value = input.value.trim();
      input.value = value;
      updateTextMirror();

      if (!input.checkValidity() || !isEmailValid(value)) {
        showInvalid();
        return;
      }

      newsletterSubmitting = true;
      clearVisualStates();
      hideCustomCaret();
      input.readOnly = true;
      submit?.setAttribute('aria-disabled', 'true');
      if (submit) submit.disabled = true;

      try {
        const response = await fetch(form.action, {
          method: (form.method || 'post').toUpperCase(),
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          redirect: 'follow'
        });

        /* A normal Shopify customer/newsletter submission generally resolves
           with HTML. The important part here is that any /contact redirect stays
           inside fetch and can never change the visible Burgintee screen. */
        if (!response.ok) throw new Error('Newsletter submission failed');
        showAcceptedThenConfirmation(value);
      } catch (error) {
        /* Keep the visitor on the mailing-list interface even if Shopify rejects
           the request; return to the existing INVALID/reset behavior rather than
           ever falling through to CONTACT/navigation. */
        input.readOnly = false;
        showInvalid();
      } finally {
        newsletterSubmitting = false;
        if (!newsletter.classList.contains('is-success')) {
          if (submit) submit.disabled = false;
          submit?.removeAttribute('aria-disabled');
        }
      }
    };

    /* Prevent the SUBMIT tap itself from bubbling into any interface navigation
       logic. This also fixes mobile/in-app browsers that synthesize an extra click. */
    submit?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      processNewsletterSubmit();
    });

    /* Keyboard submission (Return/Go) uses the exact same non-navigating path. */
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      processNewsletterSubmit();
    });
  }

  function initProduct() {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    const variantInput = root.querySelector('[data-variant-id]');
    const variantButtons = [...root.querySelectorAll('[data-variant-button]')];
    const price = root.querySelector('[data-product-price]');
    const form = root.querySelector('form');
    const add = root.querySelector('[data-add-to-bag]');
    const purchase = root.querySelector('[data-purchase-now]');
    const status = root.querySelector('[data-product-status]');

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        variantButtons.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (price && button.dataset.price) price.textContent = moneyText(button.dataset.price);
      });
    });

    async function addSelected(goToCheckout = false) {
      if (!variantInput?.value) return;
      add?.setAttribute('disabled', 'disabled');
      purchase?.setAttribute('disabled', 'disabled');
      if (status) status.textContent = 'Adding to bag';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { 'Accept': 'application/json' } });
        const cart = await cartResponse.json();
        updateBagCount(cart.item_count);
        if (status) status.textContent = 'Added to bag';
        if (goToCheckout) window.location.href = '/checkout';
      } catch (error) {
        if (status) status.textContent = 'Unable to add item';
      } finally {
        add?.removeAttribute('disabled');
        purchase?.removeAttribute('disabled');
      }
    }

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      addSelected(false);
    });

    purchase?.addEventListener('click', () => addSelected(true));
  }

  function initCart() {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;

    const frame = root.querySelector('.bt-reference-frame');
    const grid = root.querySelector('.bt-cart__grid');
    const footer = root.querySelector('.bt-footer');

    const syncCartHeight = () => {
      if (!frame || !footer) return;

      const frameRect = frame.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      if (!frameRect.height) return;

      const masterFooterTop = frameRect.height * 0.92135416667;
      let footerTop = masterFooterTop;

      if (grid) {
        const gridRect = grid.getBoundingClientRect();
        /* Keep a deliberate blank band between the final cart content and the
           policy links instead of letting the two merely avoid collision. */
        const contentBottomInFrame = gridRect.bottom - frameRect.top;
        const safeGap = frameRect.height * 0.055;
        footerTop = Math.max(masterFooterTop, contentBottomInFrame + safeGap);
      }

      root.style.setProperty('--bt-cart-footer-top', `${(footerTop / frameRect.height) * 100}%`);

      /* The reference frame is pinned to the first viewport at 50svh. Its top
         edge therefore stays stable while the page itself becomes taller. */
      const frameTopInDocument = window.scrollY + frameRect.top;
      const bottomBreathingRoom = Math.max(frameRect.height * 0.075, 56);
      const desiredDocumentBottom = frameTopInDocument + footerTop + footerRect.height + bottomBreathingRoom;
      const pageHeight = Math.max(window.innerHeight, desiredDocumentBottom);
      root.style.setProperty('--bt-cart-page-height', `${pageHeight}px`);
    };

    /* Run after layout/fonts/images settle, and whenever the viewport changes. */
    requestAnimationFrame(() => requestAnimationFrame(syncCartHeight));
    window.addEventListener('load', syncCartHeight, { once: true });
    window.addEventListener('resize', syncCartHeight);
    window.visualViewport?.addEventListener('resize', syncCartHeight);

    if (typeof ResizeObserver !== 'undefined' && grid) {
      const cartObserver = new ResizeObserver(syncCartHeight);
      cartObserver.observe(grid);
    }

    root.querySelectorAll('[data-cart-line]').forEach((line) => {
      const lineNumber = Number(line.dataset.line);
      line.querySelectorAll('[data-cart-quantity]').forEach((button) => {
        button.addEventListener('click', async () => {
          const quantity = Math.max(0, Number(button.dataset.cartQuantity));
          button.disabled = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ line: lineNumber, quantity })
            });
            if (!response.ok) throw new Error('Unable to update bag');
            window.location.reload();
          } catch (error) {
            button.disabled = false;
          }
        });
      });
    });
  }


  function initArchiveGrowth() {
    const shell = document.querySelector('[data-bt-interface]');
    const archive = shell?.querySelector('[data-bt-screen="archive"]');
    const frame = shell?.querySelector('.bt-reference-frame');
    const list = archive?.querySelector('.bt-archive-state__list');
    const footer = shell?.querySelector('.bt-footer');

    if (!shell || !archive || !frame || !list || !footer) return null;

    let raf = 0;

    const update = () => {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(() => {
        if (!shell.classList.contains('is-archive-screen') || archive.hidden) return;

        const shellRect = shell.getBoundingClientRect();
        const frameRect = frame.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        if (!frameRect.height) return;

        const originalFooterTop = frameRect.height * (1769 / 1920);
        const listBottomInsideFrame = listRect.bottom - frameRect.top;
        const contentGap = frameRect.height * (72 / 1920);
        const footerTop = Math.max(originalFooterTop, listBottomInsideFrame + contentGap);

        shell.style.setProperty('--bt-archive-footer-top', `${Math.ceil(footerTop)}px`);

        const frameTopInsideShell = frameRect.top - shellRect.top;
        const bottomBreathingRoom = frameRect.height * (128 / 1920);
        const requiredHeight = frameTopInsideShell + footerTop + footerRect.height + bottomBreathingRoom;
        const viewportFloor = window.visualViewport?.height || window.innerHeight;

        shell.style.setProperty(
          '--bt-archive-page-height',
          `${Math.ceil(Math.max(viewportFloor, requiredHeight))}px`
        );
      });
    };

    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    observer?.observe(list);

    list.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', update, { once: true });
    });

    window.addEventListener('resize', update);
    window.visualViewport?.addEventListener('resize', update);
    document.fonts?.ready?.then(update).catch(() => {});

    document.addEventListener('shopify:block:select', update);
    document.addEventListener('shopify:block:deselect', update);
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('shopify:section:reorder', update);

    return { update };
  }

  /* Archive media is view-only at the normal browser-interaction level.
     This removes the obvious right-click / long-press / drag-to-save paths
     without changing the rest of the Burgintee interface. It is intentionally
     limited to the Archive screen, its fullscreen viewer, and the legacy
     standalone Archive template. */
  function initArchiveProtection() {
    const standaloneArchives = [...document.querySelectorAll('.bt-archive')];
    const interfaceRoots = [...document.querySelectorAll('[data-archive-root]')];

    const blockContextMenu = (event) => {
      event.preventDefault();
    };

    const blockMediaDrag = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('img, video')) return;
      event.preventDefault();
    };

    standaloneArchives.forEach((archive) => {
      archive.addEventListener('contextmenu', blockContextMenu);
      archive.addEventListener('dragstart', blockMediaDrag);
      archive.querySelectorAll('img, video').forEach((media) => {
        media.setAttribute('draggable', 'false');
        if (media instanceof HTMLVideoElement) media.setAttribute('controlsList', 'nodownload');
      });
    });

    interfaceRoots.forEach((root) => {
      /* data-archive-root wraps the entire home interface, so block the menu
         only when the press actually occurs inside Archive content or viewer. */
      root.addEventListener('contextmenu', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest('[data-bt-screen="archive"], [data-archive-modal]')) return;
        event.preventDefault();
      });

      root.addEventListener('dragstart', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest('[data-bt-screen="archive"] img, [data-bt-screen="archive"] video, [data-archive-modal] img, [data-archive-modal] video')) return;
        event.preventDefault();
      });

      root.querySelectorAll(
        '[data-bt-screen="archive"] img, [data-bt-screen="archive"] video, [data-archive-modal] img, [data-archive-modal] video'
      ).forEach((media) => {
        media.setAttribute('draggable', 'false');
        if (media instanceof HTMLVideoElement) media.setAttribute('controlsList', 'nodownload');
      });
    });
  }


  function initArchiveMedia() {
    const root = document.querySelector('[data-archive-root]');
    if (!root) return;

    const modal = root.querySelector('[data-archive-modal]');
    const stage = root.querySelector('[data-archive-modal-stage]');
    const closeButton = root.querySelector('[data-archive-close]');
    const counter = root.querySelector('[data-archive-counter]');
    const peek = root.querySelector('[data-archive-peek]');

    if (!modal || !stage) return;

    let scrollRaf = 0;

    const getSlides = () => [...stage.querySelectorAll('[data-archive-slide]')];

    const pauseSlideVideos = (activeIndex = -1) => {
      getSlides().forEach((slide, index) => {
        if (index === activeIndex) return;
        slide.querySelectorAll('video').forEach((video) => {
          try { video.pause(); } catch (error) {}
        });
      });
    };

    const updateCounter = () => {
      const slides = getSlides();
      if (!counter || slides.length <= 1) {
        if (counter) counter.hidden = true;
        return;
      }

      const stageRect = stage.getBoundingClientRect();
      const centerX = stageRect.left + (stageRect.width / 2);
      let activeIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + (rect.width / 2);
        const distance = Math.abs(slideCenter - centerX);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      counter.textContent = `${activeIndex + 1}/${slides.length}`;
      counter.hidden = false;
      pauseSlideVideos(activeIndex);

      /* Give multi-media entries a physical stack: the neighbouring frame
         peeks out behind the active one, like an archival print underneath. */
      if (peek) {
        peek.replaceChildren();
        if (slides.length > 1) {
          const peekIndex = activeIndex < slides.length - 1 ? activeIndex + 1 : activeIndex - 1;
          const sourceMedia = slides[peekIndex]?.querySelector('.bt-archive-modal__image, .bt-archive-modal__video');
          if (sourceMedia) {
            const clone = sourceMedia.cloneNode(true);
            clone.classList.add('bt-archive-modal__peek-media');
            clone.removeAttribute('controls');
            clone.removeAttribute('autoplay');
            clone.removeAttribute('id');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('aria-hidden', 'true');
            if (clone.tagName === 'VIDEO') {
              clone.muted = true;
              clone.playsInline = true;
              clone.preload = 'metadata';
            }
            peek.appendChild(clone);
            peek.hidden = false;
          } else {
            peek.hidden = true;
          }
        } else {
          peek.hidden = true;
        }
      }
    };

    const stopAndClear = () => {
      window.cancelAnimationFrame(scrollRaf);
      stage.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      });
      stage.replaceChildren();
      stage.scrollLeft = 0;
      if (peek) { peek.replaceChildren(); peek.hidden = true; }
      if (counter) {
        counter.textContent = '';
        counter.hidden = true;
      }
    };

    const closeModal = () => {
      stopAndClear();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-archive-modal-open');
    };

    const openModal = (trigger) => {
      if (!trigger) return;
      const template = trigger.querySelector('template[data-archive-source]');
      if (!template) return;

      const fragment = template.content.cloneNode(true);
      const hasMedia = fragment.querySelector?.('img, video, iframe, source') || fragment.childNodes.length;
      if (!hasMedia) return;

      stopAndClear();
      stage.appendChild(fragment);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-archive-modal-open');

      /* Always open on the first frame. The stage is a native horizontal
         scroll-snap strip, so iPhone users can swipe naturally between the
         extra images/videos attached to the same Archive entry. */
      stage.scrollLeft = 0;
      window.requestAnimationFrame(() => {
        updateCounter();
        const firstVideo = getSlides()[0]?.querySelector('video');
        if (firstVideo) {
          firstVideo.currentTime = 0;
          const playPromise = firstVideo.play();
          if (playPromise?.catch) playPromise.catch(() => {});
        }
      });
    };

    stage.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollRaf);
      scrollRaf = window.requestAnimationFrame(updateCounter);
    }, { passive: true });

    /* Use one delegated listener instead of listeners bound to each block.
       This is more reliable in Shopify and iOS/Instagram webviews, and keeps
       newly added/reordered Theme Editor blocks clickable without re-init. */
    root.addEventListener('click', (event) => {
      if (!modal.hidden) return;
      const trigger = event.target?.closest?.('[data-archive-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const trigger = event.target?.closest?.('[data-archive-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });

    /* Close ONLY when the user taps physically outside displayed media.
       The full-screen strip can contain several slides; preserve every tap on
       images and native video controls, regardless of Safari event retargeting. */
    modal.addEventListener('click', (event) => {
      if (event.target?.closest?.('[data-archive-close]')) return;

      const x = event.clientX;
      const y = event.clientY;
      const mediaItems = [...stage.querySelectorAll('.bt-archive-modal__image, .bt-archive-modal__video')];
      const isInsideMedia = mediaItems.some((media) => {
        const rect = media.getBoundingClientRect();
        return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      });

      if (isInsideMedia) return;
      closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      const slides = getSlides();
      if (slides.length <= 1 || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault();

      const stageRect = stage.getBoundingClientRect();
      const currentIndex = slides.reduce((best, slide, index) => {
        const rect = slide.getBoundingClientRect();
        const distance = Math.abs((rect.left + rect.width / 2) - (stageRect.left + stageRect.width / 2));
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;

      const nextIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + (event.key === 'ArrowRight' ? 1 : -1)));
      stage.scrollTo({ left: stage.clientWidth * nextIndex, behavior: 'smooth' });
    });

    return { closeModal };
  }


  function initPasswordEllipsisCaret() {
    const shell = document.querySelector('[data-password-shell]');
    if (!shell) return;

    const input = shell.querySelector('[data-password-input]');
    const wrap = shell.querySelector('[data-password-field-wrap]');
    const mirror = shell.querySelector('[data-password-mirror]');
    const caret = shell.querySelector('[data-password-caret]');
    const enter = shell.querySelector('[data-password-enter]');
    const form = shell.querySelector('.bt-password__form');
    if (!input || !wrap || !mirror || !caret) return;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const resetBlink = () => {
      caret.style.animation = 'none';
      void caret.offsetWidth;
      caret.style.animation = '';
    };

    const maskFor = (length) => '•'.repeat(Math.max(0, length));

    const update = ({ blink = false } = {}) => {
      const value = input.value || '';
      mirror.textContent = maskFor(value.length);

      if (document.activeElement !== input) {
        caret.classList.remove('is-caret-visible');
        wrap.classList.remove('is-field-focused');
        return;
      }

      wrap.classList.add('is-field-focused');
      caret.classList.add('is-caret-visible');

      const style = window.getComputedStyle(input);
      const position = Number.isInteger(input.selectionStart) ? input.selectionStart : value.length;
      const before = maskFor(position);
      const font = `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${style.fontSize} / ${style.lineHeight} ${style.fontFamily}`;
      context.font = font;

      const paddingLeft = parseFloat(style.paddingLeft) || 0;
      const letterSpacing = parseFloat(style.letterSpacing) || 0;
      const measured = context.measureText(before).width + Math.max(0, before.length - 1) * letterSpacing;
      const maxLeft = Math.max(paddingLeft, wrap.clientWidth - caret.offsetWidth - 3);
      caret.style.left = `${Math.min(maxLeft, paddingLeft + measured)}px`;

      if (blink) resetBlink();
    };

    const hide = () => {
      caret.classList.remove('is-caret-visible');
      wrap.classList.remove('is-field-focused');
    };

    input.addEventListener('input', () => window.requestAnimationFrame(() => update({ blink: true })));
    input.addEventListener('focus', () => window.requestAnimationFrame(() => update({ blink: true })));
    input.addEventListener('blur', () => {
      hide();
      // Restore the locked composition after the iOS keyboard closes.
      window.setTimeout(() => {
        if (window.scrollX !== 0 || window.scrollY !== 0) window.scrollTo(0, 0);
      }, 80);
    });
    input.addEventListener('click', () => window.requestAnimationFrame(() => update({ blink: true })));
    input.addEventListener('keyup', () => window.requestAnimationFrame(() => update({ blink: true })));
    input.addEventListener('select', () => window.requestAnimationFrame(update));
    input.addEventListener('touchend', () => window.setTimeout(() => update({ blink: true }), 0), { passive: true });

    document.addEventListener('selectionchange', () => {
      if (document.activeElement === input) window.requestAnimationFrame(update);
    });

    const activateEnter = () => enter?.classList.add('is-active');
    enter?.addEventListener('pointerdown', activateEnter);
    enter?.addEventListener('click', activateEnter);
    form?.addEventListener('submit', () => {
      activateEnter();
      // Prevent a focused password field from leaving Safari's visual viewport panned.
      input.blur();
      window.setTimeout(() => window.scrollTo(0, 0), 0);
    });

    update();
  }

  function initInvertedMode() {
    const wordmarks = [...document.querySelectorAll('.bt-wordmark')];
    if (!wordmarks.length) return;

    const storageKey = 'burgintee-inverted';
    const rootElement = document.documentElement;
    const themeColor = document.querySelector('meta[name="theme-color"]');
    let singleTapTimer = null;

    const setMode = (inverted, { persist = true } = {}) => {
      rootElement.classList.toggle('bt-inverted', inverted);
      document.body?.classList.toggle('bt-inverted', inverted);
      themeColor?.setAttribute('content', inverted ? '#efede6' : '#000000');

      if (persist) {
        try {
          localStorage.setItem(storageKey, inverted ? '1' : '0');
        } catch (error) {}
      }
    };

    /* The head pre-applies the saved class before first paint. Sync body/meta
       once the DOM exists without rewriting the stored preference. */
    setMode(rootElement.classList.contains('bt-inverted'), { persist: false });

    const performNormalWordmarkAction = (wordmark) => {
      const interfaceRoot = document.querySelector('[data-bt-interface]');
      if (interfaceRoot) {
        interfaceRoot.dispatchEvent(new CustomEvent('burgintee:wordmark-home'));
        return;
      }

      window.location.href = window.Shopify?.routes?.root || wordmark.getAttribute('href') || '/';
    };

    wordmarks.forEach((wordmark) => {
      /* Capture the click before the wordmark's normal link/state listeners.
         One tap retains its Home action; a second tap inside the window turns
         the pair into an invert toggle instead, so the first tap never causes
         an unwanted navigation before the second arrives. */
      wordmark.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (singleTapTimer) {
          window.clearTimeout(singleTapTimer);
          singleTapTimer = null;
          setMode(!rootElement.classList.contains('bt-inverted'));
          return;
        }

        singleTapTimer = window.setTimeout(() => {
          singleTapTimer = null;
          performNormalWordmarkAction(wordmark);
        }, 300);
      }, true);
    });
  }

  function initContactEllipsisCarets() {
    const shells = [...document.querySelectorAll('[data-contact-shell]')];
    if (!shells.length) return;

    shells.forEach((shell) => {
      const email = shell.querySelector('[data-contact-email]');
      const emailWrap = shell.querySelector('[data-contact-email-wrap]');
      const emailMirror = shell.querySelector('[data-contact-email-mirror]');
      const emailCaret = shell.querySelector('[data-contact-email-caret]');
      const message = shell.querySelector('[data-contact-message]');
      const messageWrap = shell.querySelector('[data-contact-message-wrap]');
      const messageMirror = shell.querySelector('[data-contact-message-mirror]');
      const messageBefore = shell.querySelector('[data-contact-message-before]');
      const messageAfter = shell.querySelector('[data-contact-message-after]');
      const messageCaret = shell.querySelector('[data-contact-message-caret]');

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      const resetBlink = (caret) => {
        if (!caret) return;
        caret.style.animation = 'none';
        void caret.offsetWidth;
        caret.style.animation = '';
      };

      const hideEmailCaret = () => {
        emailCaret?.classList.remove('is-caret-visible');
        emailWrap?.classList.remove('is-field-focused');
      };

      const updateEmail = ({ blink = false } = {}) => {
        if (!email || !emailWrap || !emailMirror || !emailCaret) return;

        emailMirror.textContent = email.value || '';
        emailMirror.style.transform = `translate(${-email.scrollLeft}px, -50%)`;

        if (document.activeElement !== email) {
          hideEmailCaret();
          return;
        }

        emailWrap.classList.add('is-field-focused');
        const computed = window.getComputedStyle(email);
        const value = computed.textTransform === 'uppercase' ? email.value.toUpperCase() : email.value;
        let caretIndex = value.length;
        try {
          if (typeof email.selectionStart === 'number') caretIndex = email.selectionStart;
        } catch (error) {}

        const beforeCaret = value.slice(0, caretIndex);
        const paddingLeft = parseFloat(computed.paddingLeft) || 0;
        const paddingRight = parseFloat(computed.paddingRight) || 0;
        const letterSpacing = parseFloat(computed.letterSpacing) || 0;
        let textWidth = beforeCaret.length * (parseFloat(computed.fontSize) || 16) * 0.6;
        let caretWidth = parseFloat(computed.fontSize) || 16;

        if (context) {
          context.font = computed.font;
          textWidth = context.measureText(beforeCaret).width + Math.max(0, beforeCaret.length) * letterSpacing;
          caretWidth = context.measureText('…').width;
        }

        const naturalLeft = paddingLeft + textWidth - email.scrollLeft;
        const maxLeft = Math.max(paddingLeft, email.clientWidth - paddingRight - caretWidth);
        emailCaret.style.left = `${Math.max(paddingLeft, Math.min(naturalLeft, maxLeft))}px`;
        emailCaret.classList.add('is-caret-visible');
        if (blink) resetBlink(emailCaret);
      };

      const hideMessageCaret = () => {
        messageCaret?.classList.remove('is-caret-visible');
        messageWrap?.classList.remove('is-field-focused');
        messageWrap?.classList.remove('is-message-caret-at-start');
      };

      const updateMessage = ({ blink = false } = {}) => {
        if (!message || !messageMirror || !messageBefore || !messageAfter || !messageCaret) return;

        const value = message.value || '';
        let caretIndex = value.length;
        try {
          if (typeof message.selectionStart === 'number') caretIndex = message.selectionStart;
        } catch (error) {}

        if (document.activeElement === message) {
          messageWrap?.classList.add('is-field-focused');
          /* Pin character-zero to the literal top-left typing origin. This is
             especially important for an empty textarea, where an inline marker
             can otherwise inherit unexpected centering from the rendered page. */
          messageWrap?.classList.toggle('is-message-caret-at-start', caretIndex === 0);
          messageBefore.textContent = value.slice(0, caretIndex);
          messageAfter.textContent = value.slice(caretIndex);
          messageCaret.classList.add('is-caret-visible');
          if (blink) resetBlink(messageCaret);
        } else {
          messageBefore.textContent = value;
          messageAfter.textContent = '';
          hideMessageCaret();
        }
      };

      if (email) {
        email.addEventListener('input', () => window.requestAnimationFrame(() => updateEmail({ blink: true })));
        email.addEventListener('focus', () => window.requestAnimationFrame(() => updateEmail({ blink: true })));
        email.addEventListener('blur', () => { updateEmail(); hideEmailCaret(); });
        email.addEventListener('click', () => window.requestAnimationFrame(() => updateEmail({ blink: true })));
        email.addEventListener('keyup', () => window.requestAnimationFrame(() => updateEmail({ blink: true })));
        email.addEventListener('select', () => window.requestAnimationFrame(updateEmail));
        email.addEventListener('scroll', () => window.requestAnimationFrame(updateEmail), { passive: true });
        email.addEventListener('touchend', () => window.setTimeout(() => updateEmail({ blink: true }), 0), { passive: true });
        updateEmail();
      }

      if (message) {
        message.addEventListener('input', () => window.requestAnimationFrame(() => updateMessage({ blink: true })));
        message.addEventListener('focus', () => window.requestAnimationFrame(() => updateMessage({ blink: true })));
        message.addEventListener('blur', () => { updateMessage(); hideMessageCaret(); });
        message.addEventListener('click', () => window.requestAnimationFrame(() => updateMessage({ blink: true })));
        message.addEventListener('keyup', () => window.requestAnimationFrame(() => updateMessage({ blink: true })));
        message.addEventListener('select', () => window.requestAnimationFrame(updateMessage));
        message.addEventListener('touchend', () => window.setTimeout(() => updateMessage({ blink: true }), 0), { passive: true });
        updateMessage();
      }

      document.addEventListener('selectionchange', () => {
        if (document.activeElement === email) window.requestAnimationFrame(updateEmail);
        if (document.activeElement === message) window.requestAnimationFrame(updateMessage);
      });
    });
  }

  function initContactGrowth() {
    const shell = document.querySelector('[data-contact-shell]');
    if (!shell) return;

    const frame = shell.querySelector('[data-contact-frame]');
    const textarea = shell.querySelector('[data-contact-message]');
    const messageWrap = shell.querySelector('[data-contact-message-wrap]');
    const footer = shell.querySelector('.bt-footer');
    if (!frame || !textarea || !messageWrap || !footer) return;

    let baseMessageHeight = 0;

    const readBaseMessageHeight = () => {
      const computed = window.getComputedStyle(textarea);
      const minHeight = Number.parseFloat(computed.minHeight);
      baseMessageHeight = Number.isFinite(minHeight) && minHeight > 0
        ? minHeight
        : textarea.getBoundingClientRect().height;
    };

    const updatePageGrowth = () => {
      const frameHeight = frame.getBoundingClientRect().height;
      if (!frameHeight) return;

      const originalFooterTop = frameHeight * 0.92135416667;
      const footerGap = frameHeight * 0.075;
      const messageBottom = messageWrap.offsetTop + messageWrap.offsetHeight;
      const footerTop = Math.max(originalFooterTop, messageBottom + footerGap);

      shell.style.setProperty('--bt-contact-footer-top', `${footerTop}px`);

      /* Keep the master frame centered in the first viewport while allowing
         the actual document to grow beneath it. Measure the moved footer after
         its new top has been applied, then reserve a small bottom margin. */
      window.requestAnimationFrame(() => {
        const shellRect = shell.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        const bottomReserve = Math.max(48, frameHeight * 0.055);
        const requiredHeight = footerRect.bottom - shellRect.top + bottomReserve;
        shell.style.setProperty('--bt-contact-page-height', `${Math.max(window.innerHeight, requiredHeight)}px`);
      });
    };

    const resizeMessage = () => {
      /* The homepage contact panel is hidden until CONTACT is selected. Do not
         measure a display:none textarea; wait until the panel is visible. */
      if (!textarea.getClientRects().length) return;
      if (!baseMessageHeight) readBaseMessageHeight();

      /* Collapse to the baseline first so deleting lines can shrink the box
         again. scrollHeight then tells us the exact content height needed. */
      textarea.style.height = `${baseMessageHeight}px`;
      const nextHeight = Math.max(baseMessageHeight, textarea.scrollHeight);
      textarea.style.height = `${nextHeight}px`;
      updatePageGrowth();
    };

    textarea.addEventListener('input', resizeMessage);
    textarea.addEventListener('change', resizeMessage);

    window.addEventListener('resize', () => {
      baseMessageHeight = 0;
      resizeMessage();
    });

    /* Autofill, Shopify validation returns and browser-restored text can all
       be present before the first user input, so size once after layout. */
    window.requestAnimationFrame(() => {
      if (textarea.getClientRects().length) {
        readBaseMessageHeight();
        resizeMessage();
      }
    });

    return {
      update: () => {
        baseMessageHeight = 0;
        resizeMessage();
      }
    };
  }

  function initCommerceNavigationGuard() {
    const selectors = [
      '.bt-home__shop',
      '.bt-archive-state__shop',
      '.bt-statement__shop',
      '.bt-contact-state__shop',
      '.bt-shop__label',
      '.bt-product-page__shop',
      '.bt-cart__shop',
      '.bt-bag-link'
    ];

    let navigationLink = null;
    let navigationResetTimer = null;

    /* SHOP and BAG leave the current Shopify document. On iOS, two very fast
       taps can dispatch two clicks before the first navigation has finished,
       which starts competing document loads and can leave the viewport on the
       bare black background. Lock only duplicate commerce navigation in the
       CURRENT document. The destination page gets a fresh script/state, so a
       genuinely new tap there can close/leave SHOP or BAG immediately. */
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented) return;
      if (event.button != null && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = event.target instanceof Element ? event.target : null;
      const link = target?.closest(selectors.join(','));
      if (!(link instanceof HTMLAnchorElement)) return;

      const href = link.href;
      if (!href) return;

      if (navigationLink) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        return;
      }

      navigationLink = link;
      link.dataset.btNavigationPending = 'true';

      /* If a browser cancels the navigation for any reason, recover instead of
         leaving the control locked. A normal successful page load destroys this
         document long before the fallback runs. */
      navigationResetTimer = window.setTimeout(() => {
        navigationLink?.removeAttribute('data-bt-navigation-pending');
        navigationLink = null;
        navigationResetTimer = null;
      }, 1800);
    }, true);

    window.addEventListener('pagehide', () => {
      if (navigationResetTimer) window.clearTimeout(navigationResetTimer);
    }, { once: true });
  }

  function initShopEmptyReset() {
    const shopRoot = document.querySelector('.bt-shop');
    if (!shopRoot) return;

    /* SHOP is a real Shopify collection route rather than an in-place panel.
       Mirror the in-place screen behavior: tapping genuinely empty space while
       SHOP is selected returns to the untouched home screen. Real controls are
       excluded so products, BAG, wordmark, policies, and any future buttons
       keep their normal behavior. */
    shopRoot.addEventListener('click', (event) => {
      if (event.defaultPrevented) return;

      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const control = target.closest(
        'a, button, input, textarea, select, option, label, video, [role="button"], [contenteditable="true"]'
      );
      if (control) return;

      window.location.href = window.Shopify?.routes?.root || '/';
    });
  }

  function initInterfaceScreens(archiveGrowth, contactGrowth) {
    const root = document.querySelector('[data-bt-interface]');
    if (!root) return;

    const panels = [...root.querySelectorAll('[data-bt-screen]')];
    const screenTriggers = root.querySelectorAll('[data-bt-screen-target]');
    const wordmark = root.querySelector('.bt-wordmark');
    const archiveModal = root.querySelector('[data-archive-modal]');
    const policyLinks = [...root.querySelectorAll('[data-bt-policy-link]')];
    let currentScreen = 'home';

    const screenFromHash = () => {
      if (window.location.hash === '#statement') return 'statement';
      if (window.location.hash === '#archive') return 'archive';
      if (window.location.hash === '#contact') return 'contact';
      if (window.location.hash === '#terms') return 'terms';
      if (window.location.hash === '#privacy') return 'privacy';
      if (window.location.hash === '#shipping') return 'shipping';

      /* If Shopify returns the contact form with a success/error state and the
         hash was stripped during submission, reopen CONTACT automatically. */
      const contactResult = root.querySelector('[data-contact-result]')?.dataset.contactResult;
      if (contactResult === 'success' || contactResult === 'error') return 'contact';
      return 'home';
    };

    const closeArchiveModal = () => {
      if (!archiveModal || archiveModal.hidden) return;
      archiveModal.querySelectorAll('video').forEach((video) => {
        try { video.pause(); } catch (error) {}
      });
      archiveModal.querySelector('[data-archive-modal-stage]')?.replaceChildren();
      archiveModal.hidden = true;
      archiveModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-archive-modal-open');
    };

    const showScreen = (screen, options = {}) => {
      const { updateHistory = true } = options;
      const requested = panels.some((panel) => panel.dataset.btScreen === screen) ? screen : 'home';

      closeArchiveModal();

      panels.forEach((panel) => {
        const active = panel.dataset.btScreen === requested;
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      currentScreen = requested;
      root.classList.toggle('is-archive-screen', requested === 'archive');
      root.classList.toggle('is-contact-screen', requested === 'contact');
      root.classList.toggle('is-policy-screen', requested === 'terms' || requested === 'privacy' || requested === 'shipping');

      policyLinks.forEach((link) => {
        const selected = link.dataset.btPolicyLink === requested;
        link.classList.toggle('is-active', selected);
        if (selected) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (requested === 'terms' || requested === 'privacy' || requested === 'shipping') {
        const policyPanel = panels.find((panel) => panel.dataset.btScreen === requested);
        const scroller = policyPanel?.querySelector('[data-policy-scroll]');
        if (scroller) scroller.scrollTop = 0;
      }

      if (requested === 'archive') {
        window.requestAnimationFrame(() => archiveGrowth?.update());
      } else {
        root.style.removeProperty('--bt-archive-page-height');
        root.style.removeProperty('--bt-archive-footer-top');
      }

      if (requested === 'contact') {
        window.requestAnimationFrame(() => contactGrowth?.update());
      }

      if (updateHistory) {
        if (requested === 'statement' || requested === 'archive' || requested === 'contact' || requested === 'terms' || requested === 'privacy' || requested === 'shipping') {
          history.pushState({ burginteeScreen: requested }, '', `#${requested}`);
        } else {
          const cleanUrl = `${window.location.pathname}${window.location.search}`;
          history.pushState({ burginteeScreen: 'home' }, '', cleanUrl);
        }
      }
    };

    screenTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        /* Ignore any delayed/retargeted mobile click created by an invalid
           mailing-list submit. In particular, never let it open CONTACT. */
        if (root.dataset.newsletterInvalidLock) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof trigger.blur === 'function') trigger.blur();
          return;
        }

        /* Every Burgintee category is a true toggle. Tapping the category that
           is already selected closes it, removes its highlighted state, and
           restores the untouched HOME composition. */
        event.preventDefault();
        const targetScreen = trigger.dataset.btScreenTarget;

        root.dispatchEvent(new CustomEvent('burgintee:reset-newsletter'));

        if (currentScreen === targetScreen) {
          showScreen('home');
          /* A tapped footer/category link can retain browser focus after the
             screen closes. Explicitly clear both selected state and focus so
             the category returns to the normal grey immediately. */
          trigger.classList.remove('is-active');
          trigger.removeAttribute('aria-current');
          trigger.setAttribute('aria-pressed', 'false');
          if (typeof trigger.blur === 'function') trigger.blur();
        } else {
          showScreen(targetScreen);
        }
      });
    });

    wordmark?.addEventListener('click', (event) => {
      if (currentScreen !== 'home') {
        event.preventDefault();
        showScreen('home');
      }
    });

    root.addEventListener('burgintee:wordmark-home', () => {
      root.dispatchEvent(new CustomEvent('burgintee:reset-newsletter'));
      if (currentScreen !== 'home') {
        showScreen('home');
      } else {
        const cleanUrl = `${window.location.pathname}${window.location.search}`;
        if (window.location.hash) history.replaceState({ burginteeScreen: 'home' }, '', cleanUrl);
      }
    });

    /* Empty-space reset:
       When a Burgintee interface state is selected, tapping anywhere that is
       not an actual control returns to the untouched HOME composition.
       Links, buttons, inputs, archive media/title buttons, footer links and
       the visible active labels are intentionally excluded. */
    root.addEventListener('click', (event) => {
      if (event.defaultPrevented) return;
      if (archiveModal && !archiveModal.hidden) return;

      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const control = target.closest(
        'a, button, input, textarea, select, option, label, video, [role="button"], [contenteditable="true"], .is-active'
      );
      if (control) return;

      const newsletter = root.querySelector('[data-newsletter]');
      const newsletterSelected = Boolean(
        root.classList.contains('is-newsletter-confirmed') ||
        newsletter?.classList.contains('is-open') ||
        newsletter?.classList.contains('has-error') ||
        newsletter?.classList.contains('is-success')
      );

      if (currentScreen === 'home' && !newsletterSelected) return;

      root.dispatchEvent(new CustomEvent('burgintee:reset-newsletter'));
      if (currentScreen !== 'home') {
        showScreen('home');
      } else {
        const cleanUrl = `${window.location.pathname}${window.location.search}`;
        if (window.location.hash) history.replaceState({ burginteeScreen: 'home' }, '', cleanUrl);
      }
    });

    window.addEventListener('popstate', () => {
      showScreen(screenFromHash(), { updateHistory: false });
    });

    /* In the Shopify theme editor, selecting an Archive item automatically
       reveals the Archive screen so the merchant can edit visually. */
    document.addEventListener('shopify:block:select', (event) => {
      if (event.target?.closest?.('[data-archive-trigger]')) {
        showScreen('archive', { updateHistory: false });
      }
    });

    showScreen(screenFromHash(), { updateHistory: false });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const archiveGrowth = initArchiveGrowth();
    const contactGrowth = initContactGrowth();
    initInterfaceScreens(archiveGrowth, contactGrowth);
    initNewsletter();
    initContactEllipsisCarets();
    initPasswordEllipsisCaret();
    initProduct();
    initCart();
    initArchiveProtection();
    initArchiveMedia();
    initShopEmptyReset();
    initCommerceNavigationGuard();
    initInvertedMode();
  });
})();
